import { useClipboard } from "shared/lib/clipboard/useClipboard"
import { useEvent } from "shared/lib/useEvent"
import { ProductInformation } from "shared/types/__generated__/graphql"

export function useProductConfigurationAttributesClipboard(
  productInformation: ProductInformation | null | undefined
) {
  const { copy } = useClipboard()

  const copyToClipboard = useEvent(() => {
    if (!productInformation) return

    const text = productInformation.attributes
      ?.map(attr => `${attr.valueShort ?? ""}\n${attr.label}\n${attr.value}`)
      .join("\n\n")

    copy(text)
  })

  return { copyToClipboard }
}
